(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interview-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.interview-carousel');
    sections.forEach(function (section) {
      var track = section.querySelector('[data-interview-track]');
      var prev = section.querySelector('[data-interview-prev]');
      var next = section.querySelector('[data-interview-next]');
      var dotsHost = section.querySelector('[data-interview-dots]');
      if (!track) return;
      var slides = track.querySelectorAll('.ic__slide');

      function slideStep() {
        var slide = track.querySelector('.ic__slide');
        if (!slide) return 0;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function activeIndex() {
        var step = slideStep();
        if (step <= 0) return 0;
        return Math.round(track.scrollLeft / step);
      }

      /* Build one dot per slide. Only appear on mobile / touch via CSS. */
      var dotButtons = [];
      if (dotsHost && slides.length > 1) {
        dotsHost.innerHTML = '';
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: i * slideStep(), behavior: 'smooth' });
          });
          dotsHost.appendChild(b);
          dotButtons.push(b);
        });
      }

      function updateState() {
        var idx = activeIndex();
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        dotButtons.forEach(function (b, i) {
          if (i === idx) {
            b.setAttribute('aria-current', 'true');
          } else {
            b.removeAttribute('aria-current');
          }
        });
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -slideStep(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: slideStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', updateState);
      updateState();

      /* -------------------------------------------------------------
         Video tap-to-play/pause. Video autoplays muted on load; if
         autoplay is blocked (iOS low-power / reduced motion) the
         [data-paused="true"] hook keeps the big play overlay visible.
      ------------------------------------------------------------- */
      var vidBtn = section.querySelector('[data-interview-video-toggle]');
      if (vidBtn) {
        var vid = vidBtn.querySelector('video');
        function syncPaused() {
          vidBtn.setAttribute('data-paused', vid.paused ? 'true' : 'false');
        }
        vidBtn.addEventListener('click', function (e) {
          // Sound-toggle clicks bubble up here; ignore them.
          if (e.target.closest('[data-interview-video-sound]')) return;
          if (vid.paused) {
            var p = vid.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            vid.pause();
          }
        });
        vid.addEventListener('play', syncPaused);
        vid.addEventListener('pause', syncPaused);
        vid.addEventListener('ended', syncPaused);
        syncPaused();

        /* Mute / unmute toggle — starts muted (required for autoplay).
           iOS Safari sometimes ignores property-only changes, so we
           mirror the change on the attribute too. */
        var soundBtn = vidBtn.querySelector('[data-interview-video-sound]');
        if (soundBtn) {
          function syncSound() {
            var unmuted = !vid.muted;
            soundBtn.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
            soundBtn.setAttribute('aria-label', unmuted ? 'Mute video' : 'Unmute video');
          }
          function toggleSound(e) {
            e.stopPropagation();
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            if (e.type === 'keydown') e.preventDefault();
            vid.muted = !vid.muted;
            if (vid.muted) { vid.setAttribute('muted', ''); } else { vid.removeAttribute('muted'); }
            // If unmuting while paused, resume so the user hears something.
            if (!vid.muted && vid.paused) {
              var p2 = vid.play();
              if (p2 && p2.catch) p2.catch(function () {});
            }
            syncSound();
          }
          soundBtn.addEventListener('click', toggleSound);
          soundBtn.addEventListener('keydown', toggleSound);
          vid.addEventListener('volumechange', syncSound);
          syncSound();
        }
      }

      /* -------------------------------------------------------------
         Comments — fetch, render, like, compose.
         Anonymous visitors can view + click Join (→ login redirect).
         Logged-in visitors get inline compose.

         Endpoints (Drew's polymorphic /comment + /reaction API):
           - GET  /comment?entity_id={topic}&entity_type=topic
           - POST /comment                     (body: comment, entity_id, entity_type)
           - DELETE /comment/{id}
           - GET  /reaction?entity_id={comment}&entity_type=comment
           - POST /reaction?entity_id=..&entity_type=comment
           - DELETE /reaction?entity_id=..&entity_type=comment  (docs ambiguous)

         Reactions are fetched lazily per-visible-comment to avoid a
         wave of N requests on initial render.
      ------------------------------------------------------------- */
      var commentsRoot = section.querySelector('[data-interview-comments]');
      if (!commentsRoot) return;

      var API_BASE = 'https://production.api-silkorlace.com';
      var SPA_LOGIN_BASE = 'https://resale.silkorlace.com/login';
      var topicId = commentsRoot.getAttribute('data-topic-id');
      var countEl = commentsRoot.querySelector('[data-interview-comment-count]');
      var listEl = commentsRoot.querySelector('[data-interview-comment-list]');
      var composeInput = commentsRoot.querySelector('[data-interview-compose-input]');
      var composeSubmit = commentsRoot.querySelector('[data-interview-compose-submit]');
      var composeIdentity = commentsRoot.querySelector('[data-interview-compose-identity]');
      var composeUsername = commentsRoot.querySelector('[data-interview-compose-username]');
      var usernameHint = commentsRoot.querySelector('[data-interview-username-hint]');
      var HINT_DEFAULT = usernameHint ? usernameHint.textContent : '';

      // Shared: send anonymous visitors to /login, preserving current URL
      // so they land back on the interview after Auth0 completes.
      function signInRedirect() {
        var here = window.location.origin + window.location.pathname +
          window.location.search + '#' + section.id;
        window.location.href = SPA_LOGIN_BASE + '?return_to=' + encodeURIComponent(here);
      }

      var allComments = [];
      var token = (document.cookie.match(/sol_token=([^;]+)/) || [])[1];
      var currentUser = null;

      /* ------------------------------------------------------------
         Moderation queue — comments flagged by Drew's moderation get
         held locally with an "Under review" pill so the poster sees
         their submission immediately. Pruned once the server confirms
         (matched by author + text on subsequent GET /comment).
      ------------------------------------------------------------ */
      var PENDING_KEY = 'sol_pending_topic_' + topicId;
      function readPending() {
        try { return JSON.parse(localStorage.getItem(PENDING_KEY) || '[]') || []; }
        catch (e) { return []; }
      }
      function writePending(list) {
        try { localStorage.setItem(PENDING_KEY, JSON.stringify(list)); } catch (e) {}
      }
      function addPending(text) {
        if (!currentUser) return null;
        var list = readPending();
        var entry = {
          id: 'pending-' + Date.now() + '-' + Math.floor(Math.random() * 1e6),
          comment: text,
          created_at: new Date().toISOString(),
          entity_id: topicId,
          entity_type: 'topic',
          user: {
            username: currentUser.username,
            profile_pic: currentUser.profile_pic,
            is_verified: currentUser.is_verified ? 1 : 0
          },
          _pending: true
        };
        list.push(entry);
        writePending(list);
        return entry;
      }
      // Remove pending entries the server has already accepted. Matches
      // by author + exact comment text. Server rejections aren't detectable
      // from the client so those linger until localStorage clears.
      function prunePending(serverComments) {
        if (!currentUser) return [];
        var list = readPending();
        if (!list.length) return list;
        var mine = list.filter(function (p) {
          return p.user.username === currentUser.username;
        });
        var remaining = list.filter(function (p) {
          if (p.user.username !== currentUser.username) return true;
          var accepted = serverComments.some(function (c) {
            return c.user && c.user.username === currentUser.username &&
              c.comment === p.comment;
          });
          return !accepted;
        });
        if (remaining.length !== list.length) writePending(remaining);
        return remaining;
      }

      function timeAgo(dateStr) {
        var d = new Date(dateStr);
        var s = Math.max(1, Math.floor((Date.now() - d.getTime()) / 1000));
        if (s < 60) return s + 's';
        var m = Math.floor(s / 60);
        if (m < 60) return m + 'm';
        var h = Math.floor(m / 60);
        if (h < 24) return h + 'h';
        var days = Math.floor(h / 24);
        if (days < 7) return days + 'd';
        var w = Math.floor(days / 7);
        if (w < 5) return w + 'w';
        return d.toLocaleDateString();
      }

      /* ------------------------------------------------------------
         Reactions — Slack-style chip row + emoji palette. Backed by
         Drew's /reaction API. Fetched lazily per visible comment.
      ------------------------------------------------------------ */
      var REACTION_KINDS = ['like', 'love', 'care', 'laugh', 'wow', 'sad', 'angry'];
      var REACTION_EMOJI = {
        like: '👍', love: '❤️', care: '🤗',
        laugh: '😂', wow: '😮', sad: '😢', angry: '😠'
      };
      var REACTION_LABEL = {
        like: 'Like', love: 'Love', care: 'Care',
        laugh: 'Haha', wow: 'Wow', sad: 'Sad', angry: 'Angry'
      };
      var EMPTY_SUMMARY = { like: 0, love: 0, care: 0, laugh: 0, wow: 0, sad: 0, angry: 0 };

      function loadReactionsFor(comment) {
        // If we've already fetched this comment's reactions, just repaint
        // the chips against the fresh DOM row — renderList() rebuilds
        // rows whenever comments change (e.g. after a new post), so the
        // freshly-created row only has the seed add button until we
        // re-run refreshReactions.
        if (comment._reactionsLoaded) {
          var row0 = listEl.querySelector('[data-comment-id="' + comment.id + '"]');
          if (row0) refreshReactions(row0, comment);
          return;
        }
        comment._reactionsLoaded = true;
        var url = API_BASE + '/reaction?entity_id=' + encodeURIComponent(comment.id) +
          '&entity_type=comment&include_profiles=true';
        fetch(url).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (!j) return;
            comment.summary = j.summary || EMPTY_SUMMARY;
            var mine = {};
            if (currentUser) {
              (j.reactions || []).forEach(function (rx) {
                var matches = (currentUser.user_id && rx.user_id === currentUser.user_id) ||
                  (rx.user && rx.user.username === currentUser.username);
                if (matches) mine[rx.reaction] = 1;
              });
            }
            comment.mine = mine;
            var row = listEl.querySelector('[data-comment-id="' + comment.id + '"]');
            if (row) refreshReactions(row, comment);
          }).catch(function () {});
      }

      function refreshReactions(rowEl, c) {
        var wrap = rowEl.querySelector('.ic__reactions');
        if (!wrap) return;
        wrap.innerHTML = '';
        var summary = c.summary || EMPTY_SUMMARY;
        var mine = c.mine || {};
        REACTION_KINDS.forEach(function (k) {
          var count = summary[k] || 0;
          if (count <= 0) return;
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'ic__reaction-chip';
          if (mine[k]) chip.setAttribute('aria-pressed', 'true');
          chip.setAttribute('aria-label', REACTION_LABEL[k] + ' — ' + count);
          chip.innerHTML = '<span class="ic__reaction-emoji" aria-hidden="true">' +
            REACTION_EMOJI[k] + '</span>' +
            '<span class="ic__reaction-count">' + count + '</span>';
          chip.addEventListener('click', function () { toggleReaction(c, k); });
          wrap.appendChild(chip);
        });
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'ic__reaction-add';
        add.setAttribute('aria-label', 'Add reaction');
        add.innerHTML =
          '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">' +
          '<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
          '<circle cx="9" cy="10" r="0.9" fill="currentColor"/>' +
          '<circle cx="15" cy="10" r="0.9" fill="currentColor"/>' +
          '<path d="M8.5 14c.7 1 2 1.6 3.5 1.6s2.8-.6 3.5-1.6" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
          '<path d="M18.5 5v3M17 6.5h3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
          '</svg>';
        add.addEventListener('click', function (e) {
          e.stopPropagation();
          openPalette(c, add);
        });
        wrap.appendChild(add);

        // Reply button sits on the same row as reactions. Included here
        // rather than in makeCommentRow so it survives the wrap.innerHTML
        // wipe that runs whenever reactions refresh. rootId comes off
        // the row's dataset which makeCommentRow set at build time.
        var rootId = rowEl.dataset.rootId || c.id;
        var replyBtn = document.createElement('button');
        replyBtn.type = 'button';
        replyBtn.className = 'ic__comment-reply';
        replyBtn.textContent = 'Reply';
        replyBtn.addEventListener('click', function () {
          openReplyComposer(rootId, (c.user && c.user.username) || '');
        });
        wrap.appendChild(replyBtn);
      }

      /* Singleton palette popover — shared across every comment in the
         section. Positioned above the trigger on open. */
      var palette = null;
      var paletteTarget = null;
      function ensurePalette() {
        if (palette) return palette;
        palette = document.createElement('div');
        palette.className = 'ic__palette';
        palette.hidden = true;
        REACTION_KINDS.forEach(function (k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ic__palette-btn';
          b.setAttribute('aria-label', REACTION_LABEL[k]);
          b.textContent = REACTION_EMOJI[k];
          b.addEventListener('click', function (e) {
            e.stopPropagation();
            if (paletteTarget) toggleReaction(paletteTarget, k);
            closePalette();
          });
          palette.appendChild(b);
        });
        document.body.appendChild(palette);
        document.addEventListener('click', function (e) {
          if (palette.hidden) return;
          if (palette.contains(e.target)) return;
          if (e.target.closest && e.target.closest('.ic__reaction-add')) return;
          closePalette();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !palette.hidden) closePalette();
        });
        window.addEventListener('scroll', closePalette, true);
        window.addEventListener('resize', closePalette);
        return palette;
      }
      function openPalette(comment, btnEl) {
        if (!token) { signInRedirect(); return; }
        ensurePalette();
        paletteTarget = comment;
        palette.hidden = false;
        // Measure after unhide so getBoundingClientRect returns real width.
        var pw = palette.getBoundingClientRect().width;
        var pr = btnEl.getBoundingClientRect();
        var left = Math.max(8, Math.min(window.innerWidth - pw - 8, pr.left));
        palette.style.left = left + 'px';
        palette.style.top = (pr.top - palette.getBoundingClientRect().height - 8) + 'px';
      }
      function closePalette() {
        if (!palette || palette.hidden) return;
        palette.hidden = true;
        paletteTarget = null;
      }

      function makeCommentRow(c, opts) {
        opts = opts || {};
        var isReply = !!c.parent_id || !!opts.compact;
        // Reply rows nest under a top-level thread — when we're rendering
        // one, opts.rootId is passed so its own Reply button also posts
        // to the root (Instagram-flat model).
        var rootId = opts.rootId || c.id;

        var li = document.createElement('li');
        li.className = 'ic__comment';
        if (c._pending) li.classList.add('ic__comment--pending');
        if (isReply) li.classList.add('ic__comment--reply');
        li.dataset.commentId = c.id;
        // Stash the top-level root id so refreshReactions can wire the
        // Reply button on every repaint (chips flip → refresh wipes the
        // row → without this, Reply would vanish).
        li.dataset.rootId = rootId;

        // Head row: identity on the left, delete on the right (own only).
        var head = document.createElement('div');
        head.className = 'ic__comment-head';

        var user = document.createElement('span');
        user.className = 'ic__comment-user';
        var username = (c.user && c.user.username) || 'anonymous';
        user.textContent = '@' + username;

        var time = document.createElement('span');
        time.className = 'ic__comment-time';
        time.textContent = '· ' + timeAgo(c.created_at);

        head.appendChild(user);
        head.appendChild(time);

        if (c._pending) {
          var pending = document.createElement('span');
          pending.className = 'ic__comment-pending';
          pending.innerHTML =
            '<svg viewBox="0 0 24 24" width="11" height="11" aria-hidden="true">' +
            '<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.8"/>' +
            '<path d="M12 7v5l3 2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
            '</svg>' +
            '<span>Under review</span>';
          head.appendChild(pending);
        } else {
          var isOwn = !!(currentUser && c.user && c.user.username === currentUser.username);
          if (isOwn) {
            var del = document.createElement('button');
            del.type = 'button';
            del.className = 'ic__comment-delete';
            del.setAttribute('aria-label', 'Delete comment');
            del.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">' +
              '<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            del.addEventListener('click', function () { deleteComment(c, li); });
            head.appendChild(del);
          }
        }

        var body = document.createElement('p');
        body.className = 'ic__comment-body';
        body.textContent = c.comment;

        li.appendChild(head);
        li.appendChild(body);

        // Reactions bar — only for confirmed comments (pending ones have
        // no server id to react against). Chip row + add button + reply
        // button all live in the same wrap so they share a row. Reactions
        // load lazily via loadReactionsFor which calls refreshReactions
        // once the server responds; we paint the empty wrap now + delegate
        // to refreshReactions to render the initial add/reply buttons so
        // BOTH the initial paint and every refresh look identical.
        if (!c._pending) {
          var reactionsWrap = document.createElement('div');
          reactionsWrap.className = 'ic__reactions';
          li.appendChild(reactionsWrap);
          refreshReactions(li, c);
        }
        return li;
      }

      function toggleReaction(c, kind) {
        if (!token) { signInRedirect(); return; }
        c.summary = c.summary || Object.assign({}, EMPTY_SUMMARY);
        c.mine = c.mine || {};

        // Snapshot for rollback.
        var prevMine = Object.assign({}, c.mine);
        var prevSummary = Object.assign({}, c.summary);

        var wasThis = !!c.mine[kind];
        var willAdd = !wasThis;

        if (willAdd) {
          // Only add the target reaction — don't clear other reactions
          // the user has. Server truth reasserts itself via the fetch
          // in loadReactionsFor if we ever call it again; for one-per-
          // user servers we accept a brief visual flash rather than
          // aggressively clearing state that might be legitimately there.
          c.mine[kind] = 1;
          c.summary[kind] = (c.summary[kind] || 0) + 1;
        } else {
          delete c.mine[kind];
          c.summary[kind] = Math.max(0, (c.summary[kind] || 0) - 1);
        }
        var rowEl = listEl.querySelector('[data-comment-id="' + c.id + '"]');
        if (rowEl) refreshReactions(rowEl, c);

        var url = API_BASE + '/reaction?entity_id=' + encodeURIComponent(c.id) +
          '&entity_type=comment';
        var req;
        if (willAdd) {
          req = fetch(url, {
            method: 'POST',
            headers: {
              'Authorization': 'Bearer ' + token,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              entity_id: c.id,
              entity_type: 'comment',
              reaction: kind
            })
          });
        } else {
          // DELETE takes no reaction kind — removes whichever reaction
          // the caller has on this entity.
          req = fetch(url, {
            method: 'DELETE',
            headers: { 'Authorization': 'Bearer ' + token }
          });
        }
        req.then(function (r) {
          if (!r.ok) throw new Error('reaction ' + r.status);
        }).catch(function () {
          c.mine = prevMine;
          c.summary = prevSummary;
          if (rowEl) refreshReactions(rowEl, c);
        });
      }

      function deleteComment(c, rowEl) {
        if (!token) return;
        if (!window.confirm('Delete this comment?')) return;
        var prev = rowEl.style.opacity;
        rowEl.style.opacity = '0.4';
        fetch(API_BASE + '/comment/' + c.id, {
          method: 'DELETE',
          headers: { 'Authorization': 'Bearer ' + token }
        }).then(function (r) {
          if (r.status === 200) {
            allComments = allComments.filter(function (x) { return x.id !== c.id; });
            countEl.textContent = allComments.length;
            renderList();
          } else if (r.status === 401) {
            alert("You can't delete this comment.");
            rowEl.style.opacity = prev;
          } else {
            alert('Could not delete the comment. Please try again.');
            rowEl.style.opacity = prev;
          }
        }).catch(function () {
          alert('Could not delete the comment. Please try again.');
          rowEl.style.opacity = prev;
        });
      }

      /* ------------------------------------------------------------
         Threading — walks each comment's parent chain to root so even
         "reply to a reply" collapses into the top-level thread. Matches
         Instagram's flat-per-thread model + the SPA hair-closet
         implementation.
      ------------------------------------------------------------ */
      var expandedThreads = {};   // rootId -> true when expanded
      var replyComposerRoot = null; // rootId when reply composer is open
      var replyComposerTarget = ''; // username being replied to (for placeholder)

      function groupIntoThreads(list) {
        var byId = {};
        list.forEach(function (c) { byId[c.id] = c; });
        function findRoot(c) {
          if (!c.parent_id) return c;
          var parent = byId[c.parent_id];
          if (!parent) return c;
          return findRoot(parent);
        }
        var topLevel = [];
        var repliesByRoot = {};
        list.forEach(function (c) {
          if (!c.parent_id) { topLevel.push(c); return; }
          var root = findRoot(c);
          if (!repliesByRoot[root.id]) repliesByRoot[root.id] = [];
          repliesByRoot[root.id].push(c);
        });
        // Replies read chronologically down (oldest first). Top-level
        // keeps the order allComments was already in (pending + newest
        // first from the boot fetch reverse).
        var byTime = function (a, b) {
          return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
        };
        Object.keys(repliesByRoot).forEach(function (k) {
          repliesByRoot[k].sort(byTime);
        });
        return { topLevel: topLevel, repliesByRoot: repliesByRoot };
      }

      function renderList() {
        listEl.innerHTML = '';
        var threads = groupIntoThreads(allComments);
        var repliesByRoot = threads.repliesByRoot;
        threads.topLevel.forEach(function (c) {
          var row = makeCommentRow(c);
          listEl.appendChild(row);

          var replies = repliesByRoot[c.id] || [];
          if (replies.length > 0) {
            renderThreadSection(c.id, replies);
          }
          if (replyComposerRoot === c.id) {
            listEl.appendChild(makeReplyComposer(c.id, replyComposerTarget));
          }
        });
        // Lazy reaction fetches for every visible row (top-level + replies).
        allComments.forEach(function (c) { if (!c._pending) loadReactionsFor(c); });
      }

      // Renders the "View N replies" toggle + (when expanded) the reply
      // list underneath a top-level comment.
      function renderThreadSection(rootId, replies) {
        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'ic__thread-toggle';
        var isExpanded = !!expandedThreads[rootId];
        toggle.textContent = isExpanded
          ? 'Hide replies'
          : 'View ' + replies.length + ' ' + (replies.length === 1 ? 'reply' : 'replies');
        toggle.addEventListener('click', function () {
          expandedThreads[rootId] = !expandedThreads[rootId];
          renderList();
        });
        listEl.appendChild(toggle);

        if (isExpanded) {
          var replyList = document.createElement('ul');
          replyList.className = 'ic__reply-list';
          replies.forEach(function (r) {
            replyList.appendChild(makeCommentRow(r, { compact: true, rootId: rootId }));
          });
          listEl.appendChild(replyList);
        }
      }

      function openReplyComposer(rootId, targetUsername) {
        if (!token) { signInRedirect(); return; }
        replyComposerRoot = rootId;
        replyComposerTarget = targetUsername || '';
        // Auto-expand the thread so the new reply isn't hidden behind
        // the toggle once it posts.
        expandedThreads[rootId] = true;
        renderList();
      }

      function closeReplyComposer() {
        replyComposerRoot = null;
        replyComposerTarget = '';
        renderList();
      }

      // Small inline reply composer — one textarea + Post/Cancel. Posts
      // to /comment with parent_id, mirrors the main compose's optimistic
      // + moderation-pending flow.
      function makeReplyComposer(rootId, targetUsername) {
        var wrap = document.createElement('div');
        wrap.className = 'ic__reply-composer';

        var ta = document.createElement('textarea');
        ta.className = 'ic__reply-composer-input';
        ta.rows = 2;
        ta.maxLength = 1000;
        ta.placeholder = targetUsername
          ? 'Reply to @' + targetUsername + '…'
          : 'Write a reply…';
        wrap.appendChild(ta);

        var actions = document.createElement('div');
        actions.className = 'ic__reply-composer-actions';

        var cancel = document.createElement('button');
        cancel.type = 'button';
        cancel.className = 'ic__reply-composer-cancel';
        cancel.textContent = 'Cancel';
        cancel.addEventListener('click', closeReplyComposer);

        var submit = document.createElement('button');
        submit.type = 'button';
        submit.className = 'ic__reply-composer-submit';
        submit.textContent = 'Reply';
        submit.addEventListener('click', function () {
          var text = ta.value.trim();
          if (!text || !token) return;
          submit.disabled = true;
          fetch(API_BASE + '/comment', {
            method: 'POST',
            headers: {
              'Authorization': 'Bearer ' + token,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              comment: text,
              entity_id: topicId,
              entity_type: 'topic',
              parent_id: rootId
            })
          }).then(function (r) {
            if (r.ok) return r.json();
            return r.json().catch(function () { return {}; }).then(function (j) {
              var msg = extractError(j) || 'Could not post reply.';
              var err = new Error(msg);
              err.moderation = r.status === 400 && /moderat/i.test(msg);
              throw err;
            });
          }).then(function (json) {
            var newC = json.comment || json;
            if (!newC.user && currentUser) {
              newC.user = { username: currentUser.username, profile_pic: currentUser.profile_pic };
            }
            // Ensure the reply gets stitched to its root so grouping picks it up.
            if (!newC.parent_id) newC.parent_id = rootId;
            allComments.push(newC);
            countEl.textContent = allComments.length;
            closeReplyComposer();
          }).catch(function (err) {
            if (err && err.moderation) {
              // Reuse the pending-comment machinery, tagged with the
              // reply's parent_id so it renders inside the right thread.
              var pending = addPending(text);
              if (pending) {
                pending.parent_id = rootId;
                allComments.push(pending);
                countEl.textContent = allComments.length;
                closeReplyComposer();
              }
              return;
            }
            alert((err && err.message) || 'Could not post reply.');
            submit.disabled = false;
          });
        });

        actions.appendChild(cancel);
        actions.appendChild(submit);
        wrap.appendChild(actions);

        // Focus the textarea on next tick so the browser scrolls it into
        // view naturally after the composer is added to the DOM.
        setTimeout(function () { ta.focus(); }, 0);
        return wrap;
      }

      /* Compose is always visible. Its state (auth vs anonymous) is set
         by applyComposeState() once we know whether the visitor has a
         token + profile. Anonymous → disabled input + "Sign in to
         comment" button that redirects to Auth0. Logged-in → normal
         compose with identity strip and Post button. */
      function resetUsernameHint() {
        if (!usernameHint) return;
        usernameHint.textContent = HINT_DEFAULT;
        usernameHint.removeAttribute('data-error');
      }
      function showUsernameError(msg) {
        if (!usernameHint) return;
        usernameHint.textContent = msg;
        usernameHint.setAttribute('data-error', 'true');
      }
      function applyComposeState() {
        if (currentUser) {
          composeInput.disabled = false;
          composeInput.placeholder = 'Join the conversation';
          if (composeIdentity) composeIdentity.hidden = false;
          if (usernameHint) usernameHint.hidden = false;
          composeUsername.value = currentUser.username || '';
          resetUsernameHint();
          composeSubmit.textContent = 'Post';
        } else {
          composeInput.disabled = true;
          composeInput.placeholder = 'Join the conversation';
          if (composeIdentity) composeIdentity.hidden = true;
          if (usernameHint) usernameHint.hidden = true;
          composeSubmit.textContent = 'Sign in to comment';
        }
      }
      composeUsername.addEventListener('input', resetUsernameHint);
      // Focus on the disabled textarea also routes to sign-in — one more
      // way in for anonymous visitors who tap the input area first.
      composeInput.addEventListener('click', function () {
        if (!currentUser) signInRedirect();
      });
      // Pull an error message out of any of the 3 shapes Drew's API uses
      // ({error}, {message}, {message: {error}}) — same normalization the
      // SPA does in lib/query.ts.
      function extractError(json) {
        if (!json) return '';
        if (typeof json.error === 'string') return json.error;
        if (typeof json.message === 'string') return json.message;
        if (json.message && typeof json.message.error === 'string') return json.message.error;
        return '';
      }

      composeSubmit.addEventListener('click', function () {
        // Anonymous → route to sign-in (same button doubles as CTA + submit).
        if (!token || !currentUser) { signInRedirect(); return; }
        var text = composeInput.value.trim();
        if (!text) return;
        var wantUsername = (composeUsername.value || '').trim();
        var currentUsername = (currentUser && currentUser.username) || '';
        composeSubmit.disabled = true;
        resetUsernameHint();

        // Step 1: PATCH the profile only if the user actually changed the
        // name. Skips the round-trip in the common case where they leave
        // their username alone. Endpoint matches the SPA's useUpdateProfile
        // (PATCH /profile/me → { profile: {...} }); per Drew, /account
        // does NOT accept username updates.
        var profileStep;
        if (wantUsername && wantUsername !== currentUsername) {
          profileStep = fetch(API_BASE + '/profile/me', {
            method: 'PATCH',
            headers: {
              'Authorization': 'Bearer ' + token,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ username: wantUsername })
          }).then(function (r) {
            if (r.ok) return r.json().then(function (j) { return { ok: true, user: j.profile || j.user || j }; });
            return r.json().catch(function () { return {}; }).then(function (j) {
              var msg = extractError(j) || (r.status === 409
                ? 'That username is already taken. Try another.'
                : 'Could not update your username. Please try again.');
              return { ok: false, msg: msg };
            });
          });
        } else {
          profileStep = Promise.resolve({ ok: true, user: currentUser });
        }

        profileStep.then(function (profileResult) {
          if (!profileResult.ok) {
            showUsernameError(profileResult.msg);
            composeSubmit.disabled = false;
            composeUsername.focus();
            composeUsername.select();
            return;
          }
          // Update in-memory user so subsequent opens prefill the new
          // name, and so the comment we're about to post gets tagged
          // with it in the optimistic render.
          if (profileResult.user) currentUser = profileResult.user;

          // Step 2: post the comment now that identity is settled.
          // Polymorphic /comment endpoint — entity_id + entity_type in the body.
          fetch(API_BASE + '/comment', {
            method: 'POST',
            headers: {
              'Authorization': 'Bearer ' + token,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              comment: text,
              entity_id: topicId,
              entity_type: 'topic'
            })
          }).then(function (r) {
            if (r.ok) return r.json();
            // Non-2xx: parse the body so we can distinguish moderation
            // holds from other failures.
            return r.json().catch(function () { return {}; }).then(function (j) {
              var msg = extractError(j) || 'Could not post comment. Please try again.';
              var isModeration = r.status === 400 && /moderat/i.test(msg);
              var err = new Error(msg);
              err.moderation = isModeration;
              throw err;
            });
          }).then(function (json) {
            var newC = json.comment || json;
            if (!newC.user && currentUser) {
              newC.user = { username: currentUser.username, profile_pic: currentUser.profile_pic };
            }
            allComments.unshift(newC);
            countEl.textContent = allComments.length;
            renderList();
            composeInput.value = '';
          }).catch(function (err) {
            if (err && err.moderation) {
              // Moderation hold: show the comment locally with an
              // "Under review" pill so the poster sees their submission.
              // Persists across reloads via localStorage; prunes itself
              // when Drew's moderator approves and the comment shows up
              // via GET /comment.
              var pending = addPending(text);
              if (pending) {
                allComments.unshift(pending);
                countEl.textContent = allComments.length;
                renderList();
                composeInput.value = '';
              }
              return;
            }
            alert((err && err.message) || 'Could not post comment. Please try again.');
          }).finally(function () {
            composeSubmit.disabled = false;
          });
        });
      });

      /* Boot: fetch current user (if token) + comments. */
      (function boot() {
        var userPromise = token
          ? fetch(API_BASE + '/profile/me', {
              headers: { 'Authorization': 'Bearer ' + token }
            }).then(function (r) { return r.ok ? r.json() : null; })
              .then(function (j) { return j && j.profile; })
              .catch(function () { return null; })
          : Promise.resolve(null);

        Promise.all([
          userPromise,
          fetch(API_BASE + '/comment?entity_id=' + encodeURIComponent(topicId) +
            '&entity_type=topic')
            .then(function (r) { return r.ok ? r.json() : { comments: [] }; })
            .catch(function () { return { comments: [] }; })
        ]).then(function (results) {
          currentUser = results[0];
          var serverComments = (results[1].comments || []).slice().reverse();

          // Merge in any moderation-held pending comments the current
          // user posted from this browser. Prune ones the server has
          // now accepted (matched by author + comment text).
          var pending = prunePending(serverComments);
          // Newest pending first — addPending appends in creation order.
          var myPending = currentUser
            ? pending.filter(function (p) { return p.user.username === currentUser.username; }).reverse()
            : [];
          // Pending comments render at the top (newest-first) alongside
          // freshly posted ones — allComments is already newest-first.
          allComments = myPending.concat(serverComments);

          countEl.textContent = allComments.length;
          // Toggle compose between signed-in (Post) and anonymous
          // (Sign in to comment) now that we know who's here.
          applyComposeState();
          // renderList() below will kick off lazy reaction fetches for
          // whichever comments are actually visible.
          renderList();
        });
      })();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
